<div class="topbar clearfix cbet-topbar">
    <div class="topbar-left">
        <a routerLink="/">
            <img [src]="urlImageLogo" class="topbar-logo" [alt]="marca"/>
        </a>
    </div>

    <div class="topbar-right">
        <a id="menu-button" href="#" (click)="main?.onMenuButtonClick($event)"
           [ngClass]="{'menu-button-rotate': main?.rotateMenuButton}">
            <i class="pi pi-angle-left"></i>
        </a>

        <div class="cbet-topbar-context">
            <app-context-switcher
                [shortcuts]="shortcuts"
                [printerVisible]="isTypeClientPrintCoffe"
                [printerConnected]="statusClientPrinterCoffe"
                (printerClick)="printerClientsVisible = true"
                [whatsappVisible]="whatsappVisible"
                [whatsappConnected]="whatsappConnected"
                [whatsappRoute]="whatsappRoute">
            </app-context-switcher>
        </div>

        <!-- Móvil: accesos directos en un botón propio, fuera del desplegable -->
        <a href="#" class="cbet-topbar-mas" *ngIf="shortcuts?.length"
           (click)="$event.preventDefault(); shortcutsMenu.toggle($event)" aria-label="Accesos directos">
            <i class="pi pi-ellipsis-h"></i>
        </a>

        <a id="topbar-menu-button" href="#" (click)="main?.onTopbarMenuButtonClick($event)" aria-label="Menú de usuario">
            <i class="pi pi-bars"></i>
        </a>

        <ul class="topbar-items fadeInDown" [ngClass]="{'topbar-items-visible': main?.topbarMenuActive}">
            <li class="cbet-shortcuts" *ngIf="shortcuts?.length">
                <a *ngFor="let item of inlineShortcuts" class="cbet-shortcut" [routerLink]="item?.ruta" [queryParams]="item?.queryParams"
                   [pTooltip]="item?.nombre" tooltipPosition="bottom" [attr.aria-label]="item?.nombre">
                    <i *ngIf="item?.icono" [class]="'topbar-icon ' + (item.icono | iconoPrime)"></i>
                    <span class="topbar-item-name">{{item?.nombre}}</span>
                </a>
                <span class="cbet-shortcuts-divider"></span>
                <a href="#" class="cbet-shortcut" (click)="$event.preventDefault(); shortcutsMenu.toggle($event)"
                   pTooltip="Accesos directos" tooltipPosition="bottom" aria-label="Accesos directos">
                    <i class="topbar-icon pi pi-ellipsis-h"></i>
                    <span class="topbar-item-name">Más accesos</span>
                </a>
            </li>

            <li class="cbet-status" *ngIf="whatsappVisible">
                <a [routerLink]="whatsappRoute"
                   [pTooltip]="whatsappConnected ? 'WhatsApp: sesión activa' : 'WhatsApp: sin sesión, clic para conectar'"
                   tooltipPosition="bottom">
                    <i class="topbar-icon pi pi-whatsapp"></i>
                    <span class="cbet-status-dot" [class.is-ok]="whatsappConnected"></span>
                    <span class="topbar-item-name">WhatsApp</span>
                </a>
            </li>

            <li class="cbet-status" *ngIf="isTypeClientPrintCoffe">
                <a href="#" (click)="$event.preventDefault(); printerClientsVisible = true"
                   [pTooltip]="printerConnectionLabel + ' Ver equipos de toda la empresa.'" tooltipPosition="bottom">
                    <i class="topbar-icon pi pi-print"></i>
                    <span class="cbet-status-dot" [class.is-ok]="statusClientPrinterCoffe"></span>
                    <span class="topbar-item-name">Impresión</span>
                </a>
            </li>

            <li class="cbet-topbar-sep" *ngIf="shortcuts?.length || whatsappVisible || isTypeClientPrintCoffe"></li>

            <li class="cbet-topbar-bell">
                <app-notification-indicator></app-notification-indicator>
            </li>

            <li class="cbet-topbar-sep"></li>

            <li #settings [ngClass]="{'active-top-menu': main?.activeTopbarItem === settings}">
                <a href="#" (click)="main?.onTopbarItemClick($event, settings)" pTooltip="Configuración" tooltipPosition="bottom">
                    <i class="topbar-icon pi pi-cog"></i>
                    <span class="topbar-item-name">Configuración</span>
                </a>
                <ul class="layout-menu" [ngClass]="{'fadeInDown': !main?.isMobile()}">
                    <li role="menuitem" *appPermission="'CAMBIAR_CONFIGURACION'">
                        <a routerLink="/mi-empresa">
                            <i class="pi pi-fw pi-building"></i>
                            <span>Mi empresa</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a routerLink="/facturacion">
                            <i class="pi pi-fw pi-wallet"></i>
                            <span>Facturación</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a routerLink="/accesos-directos">
                            <i class="pi pi-fw pi-star"></i>
                            <span>Accesos directos</span>
                        </a>
                    </li>
                </ul>
            </li>

            <li #profile class="profile-item" [ngClass]="{'active-top-menu': main?.activeTopbarItem === profile}">
                <a href="#" (click)="main?.onTopbarItemClick($event, profile)">
                    <img class="profile-image" [src]="main?.userLogin?.avatarUrl" (error)="onAvatarError($event)" alt="avatar"/>
                    <div class="cbet-profile-text">
                        <span class="topbar-item-name">{{main?.userLogin?.name}}</span>
                        <span class="topbar-item-role">({{main?.userLogin?.cargo}})</span>
                    </div>
                </a>

                <ul class="layout-menu" [ngClass]="{'fadeInDown': !main?.isMobile()}">
                    <li role="menuitem">
                        <a routerLink="/mi-perfil">
                            <i class="pi pi-fw pi-user"></i>
                            <span>Mi perfil</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a routerLink="/cambiar-clave">
                            <i class="pi pi-fw pi-lock"></i>
                            <span>Cambiar contraseña</span>
                        </a>
                    </li>
                    <li class="theme-profile-entry" role="presentation"><app-theme-toggle></app-theme-toggle></li>
                    <li role="menuitem">
                        <a routerLink="/logout">
                            <i class="pi pi-fw pi-sign-out"></i>
                            <span>Cerrar sesión</span>
                        </a>
                    </li>
                    <li role="presentation" class="cbet-topbar-version">{{marca}} v{{appVersion$ | async}}</li>
                </ul>
            </li>
        </ul>
    </div>
</div>

<p-menu #shortcutsMenu [popup]="true" [model]="shortcutsMenuItems" appendTo="body"></p-menu>

<app-printer-clients-dialog *ngIf="isTypeClientPrintCoffe" [(visible)]="printerClientsVisible"></app-printer-clients-dialog>
